<template>
  <div class="regions-calc-container">
    <div class="title">Kalkulation (netto)</div>
    <p v-if="regions.length > 0">
      <label for="max-qty-input">Legen Sie die maximale Anzahl der Empfänger fest.</label>
    </p>
    <div class="max" :class="{ hidden: regions.length === 0 }">
      <div id="range-slider">
        <!-- ionRangeSlider keeps this input in the DOM (hidden, tabindex -1); name it for assistive tech -->
        <input
          type="text"
          name="max-qty"
          id="max-qty"
          maxlength="9"
          value="50000"
          class="input-text qty"
          aria-label="Maximale Anzahl der Empfänger (Schieberegler)"
        />
      </div>
      <div class="qty-holder">
        <!-- aria-label as fallback: the visible label above only exists once regions are selected -->
        <input
          type="text"
          id="max-qty-input"
          maxlength="9"
          value="50000"
          class="input-text qty"
          aria-label="Maximale Anzahl der Empfänger"
        />

        <div class="qty-changer">
          <a href="javascript:void(0)" id="max-qty-plus"><i class="icon-up-dir"></i></a>
          <a href="javascript:void(0)" id="max-qty-minus"><i class="icon-down-dir"></i></a>
        </div>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Verteilgebiet</th>
          <th style="text-align: right">Haushalte</th>
          <th style="text-align: right">Verteilung</th>
          <th style="text-align: right">Aufzahlung</th>
          <th style="text-align: right">Verteilkosten</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="regions.length === 0">
          <td colspan="7">
            Bitte planen Sie über das Eingabefeld das gewünschte Verteilgebiet.
          </td>
        </tr>
        <tr v-for="region in regions" :key="region.id">
          <td>{{ region.label }}</td>
          <td style="text-align: right">
            {{ new Intl.NumberFormat().format(region.potenzial) }}
          </td>
          <td style="text-align: right">
            {{ new Intl.NumberFormat().format(region.gefiltert) }}
          </td>
          <td>&nbsp;</td>
          <td style="text-align: right">
            {{
              new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
              }).format(region.verteilkosten)
            }}
          </td>
          <td style="text-align: left; width: 100%">
            <i
              @click="deleteRegion(region)"
              class="fa fa-times-circle"
              style="font-style: normal; cursor: pointer"
            ></i>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="regions.length > 0">
        <tr class="sum">
          <td>Summe&nbsp;Verteilkosten:</td>
          <td style="text-align: right">
            <span>
              {{ new Intl.NumberFormat().format(totals.potenzial) }}
            </span>
          </td>
          <td style="text-align: right" class="sum">
            <span>
              {{ new Intl.NumberFormat().format(totals.anzahl) }}
            </span>
          </td>
          <td style="text-align: right" class="sum">
            <span>
              {{ new Intl.NumberFormat().format(totals.aufzahlungen) }}
            </span>
          </td>
          <td style="text-align: right">
            <span>
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(totals.verteilkosten)
              }}
            </span>
          </td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>Druckkosten:</td>
          <template v-if="!calc.message && calc.price > 0">
            <td>&nbsp;</td>
            <td style="text-align: right" class="sum">
              <span>
                {{ new Intl.NumberFormat().format(totals.anzahl) }}
              </span>
            </td>
            <td>&nbsp;</td>
            <td style="text-align: right">
              <span>
                {{
                  new Intl.NumberFormat("de-DE", {
                    style: "currency",
                    currency: "EUR",
                  }).format(calc.price)
                }}
              </span>
            </td>
          </template>
          <template v-else>
            <td colspan="4" style="text-align: right">
              {{ calc.message }}
            </td>
          </template>
          <td>&nbsp;</td>
        </tr>
        <tr class="sum">
          <td>Gesamtkosten:</td>
          <td colspan="4" style="text-align: right">
            <span v-if="!calc.message && calc.price > 0">
              {{
                new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(totals.gesamtsumme)
              }}
            </span>
          </td>
          <td>&nbsp;</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  name: "RegionsCalc",
  props: {
    regions: Array,
    totals: Object,
    calc: Object,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    // Number Slider
    var $range = jQuery("#max-qty"),
      $input = jQuery("#max-qty-input"),
      $btn_minus = jQuery("#max-qty-minus"),
      $btn_plus = jQuery("#max-qty-plus"),
      instance,
      min = 200,
      max = 50000,
      step = 1000,
      from = 50000;

    function prettify(num) {
      var n = num.toString();
      return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + ".");
    }

    $range.ionRangeSlider({
      type: "single",
      min: min,
      max: max,
      from: from,
      step: step,
      prettify_enabled: true,
      prettify_separator: ".",
      onStart: function (data) {
        $input.prop("value", prettify(data.from));
      },
      onChange: function (data) {
        $input.prop("value", prettify(data.from));
      },
      onFinish: () => {
        this.$emit("update-filters");
      },
    });

    instance = $range.data("ionRangeSlider");

    $btn_minus.on("click", function () {
      updateRange(instance.result.from - 1);
      $input.prop("value", prettify(from));
    });

    $btn_plus.on("click", function () {
      updateRange(instance.result.from + 1);
      $input.prop("value", prettify(from));
      // this.$emit("update-filters");
    });

    $input.on("change keyup", function () {
      updateRange(jQuery(this).prop("value").replace(/\D/g, ""));
    });

    var updateRange = (val) => {
      from = parseInt(val);
      if (from < min) {
        from = min;
      } else if (from > max) {
        from = max;
      }

      if (instance !== undefined) {
        instance.update({
          from: from,
        });
      } else {
        $input.prop("value", prettify(from));
      }

      this.$emit("update-filters");
    };
  },
  methods: {
    typ(typ) {
      if (typ === "lz") {
        return "Leitzone";
      } else if (typ === "lr") {
        return "Leitregion";
      } else if (typ === "plz") {
        return "Postleitzahl";
      }
    },
    deleteRegion(region) {
      this.$emit("delete-region", region);
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: 800;
  font-size: 18px;
  margin-bottom: 5px;
}

tfoot {
  color: #ce1a0f;

  tr td {
    border: 0;
  }

  .sum td {
    border-top: solid 2px #ce1a0f;
  }
}

.max {
  margin-bottom: 30px;
}

.qty-holder {
  width: 100%;
  display: block;
  margin-right: 0;
  position: relative;
  vertical-align: middle;
}

.qty {
  width: 100% !important;
  font-size: 20px;
}

.qty-changer {
  position: absolute;
  top: 0;
  right: 0;
  display: inline-block;
  vertical-align: middle;

  a {
    width: 16px;
    height: 16px;
    display: block;
    border: 1px solid #e1e1e1;
    color: #ccc;
    line-height: 14px;
    text-align: center;
    margin-bottom: 6px;
    border-radius: 3px;
    font-size: 8px;
    background-color: #fff;
  }
}
</style>
